export const parseMessagesByDate = messagesArray => {
  let objByDate = {};
  messagesArray.forEach(message => {
    const dateCreated = new Date(message.dateCreated);
    const isoString = dateCreated.toISOString();
    const getShortDate = isoString.substr(0, 10);
    if (objByDate[getShortDate] && Array.isArray(objByDate[getShortDate])) {
      objByDate[getShortDate].push({
        dateCreated: new Date(message.dateCreated),
        body: message.body,
        author: message.author,
        index: message.index
      });
    } else {
      objByDate[getShortDate] = [{
        dateCreated: new Date(message.dateCreated),
        body: message.body,
        author: message.author,
        index: message.index
      }];
    }
  });
  return objByDate;
};
//# sourceMappingURL=parseMessageByDate.js.map